import { statusFilterToActive } from 'src/app/shared/utilities/status-filter';
import { UntypedFormControl } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PartnerService } from '../services/partner.service';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { IPartner, IListByFilterParceiros, IExportExcelFilterParceiros } from '../models/partner.interface';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit, OnDestroy {
  ERoleAdminString = ERoleAdminString;
  private readonly destroy$ = new Subject<void>();
  ordenarControl = new UntypedFormControl(1);
  acaoInput = new UntypedFormControl();
  statusControl = new UntypedFormControl('all');
  partners: IPartner[] = [];
  dadosPaginacao = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  listOrder = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];
  constructor(
    private readonly PartnerService: PartnerService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.carregarParceiros();
    this.ordenarControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((ordenacaoSelecionada: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = ordenacaoSelecionada;
      this.recarregarDoInicio();
    });

    this.statusControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.recarregarDoInicio();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  filtrarParceiro(): void {
    this.recarregarDoInicio();
  }
  limparFiltros(): void {
    this.acaoInput.reset();
    this.statusControl.reset('all', { emitEvent: false });
    this.recarregarDoInicio();
  }
  carregarParceiros(): void {
    const filtros = this.montarFiltros();

    this.PartnerService.listarTodosParceiros(filtros).subscribe((resposta) => {
      this.partners = resposta.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(resposta.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = resposta.count!;
    });
  }

  /** Mudou um filtro, a ordenação ou o tamanho da página: a página atual pode não existir mais. */
  private recarregarDoInicio(): void {
    this.dadosPaginacao.paginaSelecionada = 0;
    this.carregarParceiros();
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;
    this.carregarParceiros();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.recarregarDoInicio();
  }

  public downloadExcel(): void {
    this.PartnerService.exportarExcelParceiros(this.montarFiltros());
  }

  /** Mesmos filtros na listagem e no Excel, para o arquivo trazer o que está na tela. */
  private montarFiltros(): IListByFilterParceiros {
    const partnerId = this.sessionService.getSession().partnerId;
    const accountRole = this.sessionService.getSession().accountRole;

    const filtros: IListByFilterParceiros = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina),
      active: statusFilterToActive(this.statusControl.value)
    };

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (this.acaoInput.value) {
      filtros.searchText = String(this.acaoInput.value);
    }

    return filtros;
  }
}
